import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import {
  DEL_CHANNELS_IMAGES,
  ADD_CHANNELS_IMAGES,
  UPDATE_CHANNELS_IMAGES,
} from "../../../store/constants/serviceEndpoint";
import * as enums from "../../../common/enum";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import Swal from "sweetalert2";

const initData = {
  id: null,
  channelId: 0,
  eventImageId: 0,
};

export default function ImageWithChannel({
  data = [],
  listChannel = [],
  eventId,
  onReloadData,
}) {
//   console.log(data, listImage, listChannel);
  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState(initData);
  const [loading, setLoading] = useState(false);

  const onShowItem = (e, item) => {
    e.preventDefault();
    setVisible(true);
    setItem(item);
    // console.log(item);
  };

  const deleteItem = (e, id) => {
    Swal.fire({
      title: "Thông báo",
      text: "Bạn có muốn xóa cài đặt này không ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý!",
      cancelButtonText: "Trở về",
    }).then((result) => {
      if (result.value) {
        setLoading(true);
        axiosWithHeaders("post", DEL_CHANNELS_IMAGES, { Id: id })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.status === enums.RESPONSE_OK
            ) {
              const { status, message } = response.data;
              if (status === enums.RESPONSE_OK) {
                Swal.fire("Thông báo", "Xoá cài đặt thành công !", "success");
                if (typeof onReloadData === "function") onReloadData(eventId);
              } else {
                Swal.fire("Lỗi", message, "error");
              }
            }
          })
          .catch((error) => alert(error.toString()))
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const cellTemplate = (row, column) => {
    const field = column.field;
    switch (field) {
      case "isRequire":
        return <Checkbox checked={row["isRequire"]} disabled></Checkbox>;
      default:
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <Button
              icon="pi pi-pencil"
              className="p-button-success p-button-raised"
              style={{ marginRight: 7, width: 35 }}
              onClick={(e) => onShowItem(e, row)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-raised"
              style={{ width: 35 }}
              onClick={(e) => deleteItem(e, row.id)}
              disabled={!row.id ? true : false}
            />
          </div>
        );
    }
  };

  const onAddData = (e) => {
    e.preventDefault();

    const objAdd = {
      ChannelId: item.channelId,
      EventImageId: item.eventImageId,
      IsRequied: item.isRequire ? 1 : 0,
    };
    setLoading(true);
    axiosWithHeaders("post", ADD_CHANNELS_IMAGES, objAdd)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Thêm thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((error) => {
        Swal.fire("Lỗi", error.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onUpdateData = (e) => {
    e.preventDefault();

    const objUpdate = {
      ChannelId: item.channelId,
      EventImageId: item.eventImageId,
      IsRequied: item.isRequire ? 1 : 0,
      id: item.id,
    };

    // console.log(objUpdate);

    setLoading(true);
    axiosWithHeaders("post", UPDATE_CHANNELS_IMAGES, objUpdate)
      .then((response) => {
        console.log(response);
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Cập nhật thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((error) => {
        Swal.fire("Lỗi", error.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onCancel = (e) => {
    if (e) e.preventDefault();
    setVisible(false);
    setItem(initData);
  };

  const footer = (
    <>
      {item && item.id ? (
        <Button
          label="Cập nhật"
          icon="pi pi-check"
          onClick={onUpdateData}
          className="p-button-raised"
          loading={loading}
        />
      ) : (
        <Button
          label="Xác nhận"
          icon="pi pi-check"
          onClick={onAddData}
          className="p-button-raised"
          loading={loading}
        />
      )}
      <Button
        label="Hủy"
        icon="pi pi-times"
        onClick={onCancel}
        className="p-button-raised p-button-secondary"
        loading={loading}
      />
    </>
  );

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-center`}
        >
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT HÌNH THEO KÊNH
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <DataTable
            value={data}
            rowGroupMode="rowspan"
            sortField="channelName"
            sortOrder={1}
            groupField="channelName"
            style={{ marginTop: "30px" }}
          >
            <Column field="channelName" header="Kênh" />
            <Column field="nameImage" header="Tên hình" />
            <Column
              field="isRequire"
              header="Bắt buộc"
              body={(row, column) => cellTemplate(row, column)}
              style={{ textAlign: "center" }}
            />
            <Column
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
          </DataTable>
        </div>
      </div>
      <Dialog
        header="Cập nhật hình theo kênh"
        footer={footer}
        visible={visible}
        style={{ width: "600px" }}
        modal={true}
        onHide={onCancel}
      >
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtChannelName">Kênh</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="txtChannelName"
              value={item && item.channelId ? item.channelId : 0}
              optionValue="id"
              optionLabel="name"
              options={listChannel}
              onChange={(e) => {
                setItem({ ...item, channelId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm kênh"
              filterBy="id,name"
              placeholder="Chọn kênh"
              style={{ width: "100%" }}
              disabled
            />
          </div>
        </div>

        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtEventImage">Loại hình</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="txtEventImage"
              value={item && item.eventImageId ? item.eventImageId : 0}
              options={data}
              optionValue="eventImageId"
              optionLabel="nameImage"
              onChange={(e) => {
                setItem({ ...item, eventImageId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm hình"
              filterBy="label,value"
              placeholder="Chọn loại hình"
              style={{ width: "100%" }}
              disabled
            />
          </div>
        </div>

        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right"></div>
          <div className="col-md-6">
            <Checkbox
              checked={item && item.isRequire ? item.isRequire : false}
              inputId="cb2"
              onChange={(e) => setItem({ ...item, isRequire: e.checked })}
            ></Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              &nbsp;Bắt buộc ?
            </label>
          </div>
        </div>

        {/* <div className="p-grid" style={{ marginTop: 5 }}>
          <div
            className="p-col-4"
            style={{ paddingBottom: 0, textAlign: "right" }}
          >
            <label>Loại hình</label>
          </div>
          <div className="p-col-6" style={{ paddingTop: 0 }}>
            <Dropdown
              value={this.state.EventImageId}
              options={this.state.listImage}
              onChange={(e) => {
                this.setState({ EventImageId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm hình"
              filterBy="label,value"
              placeholder="Chọn loại hình"
              disabled
            />
          </div>
        </div>
        <div className="p-grid" style={{ marginTop: 5 }}>
          <div
            className="p-col-4"
            style={{ paddingBottom: 0, textAlign: "right" }}
          ></div>
          <div className="p-col-6" style={{ paddingTop: 0 }}>
            <Checkbox
              checked={this.state.isRequire}
              inputId="cb2"
              onChange={(e) => this.setState({ isRequire: e.checked })}
            ></Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Bắt buộc ?
            </label>
          </div>
        </div> */}
      </Dialog>
    </>
  );
}
